var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjuryFingerLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 21,
    viewBox: "0 0 10 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.074 0c.377 5.415-.588 10.288-2.896 14.62-3.462 6.496 1.656 6.245 3.214 2.834 1.558-3.41 4.423-9.553 4.057-10.908C9.204 5.642 7.746 3.46 5.074 0z",
    fill: "#FC5A56",
    stroke: "#FC5A56",
    fillRule: "evenodd",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjuryFingerLeft);
export default __webpack_public_path__ + "static/media/injury-finger-left.c4414aba3f8a66020586c66db46c9a6e.svg";
export { ForwardRef as ReactComponent };